<template>
  <nav
      class="shadow-none navbar navbar-main navbar-expand-lg border-radius-xl"
      v-bind="$attrs"
      id="navbarBlur"
      data-scroll="true"
      :class="isAbsolute ? 'mt-4' : 'mt-0'"
  >
    <div
        class="px-3 pt-0 pb-1 container-fluid d-flex align-items-center justify-content-between"
        style="min-height: 60px;"
    >

      <!-- ✅ Fixed logo class and made it fully controllable -->
      <div class="d-flex align-items-center logo-wrapper">
        <img src="@/assets/integration_logo.png" alt="Integration Logo" class="integration-logo" />
      </div>

      <!-- Breadcrumbs -->
      <div class="flex-grow-1 ms-3">
        <breadcrumbs :currentPage="currentRouteName" :color="color" />
      </div>

      <!-- Right-side user section -->
      <div class="d-flex align-items-center">
        <ul class="navbar-nav mx-3 justify-content-end">
          <!-- User Dropdown -->
          <li class="nav-item dropdown">
            <a
                class="nav-link d-flex align-items-center py-0"
                href="#"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                :class="color || 'text-body'"
            >
              <i class="material-icons" :class="isRTL ? 'ms-sm-2' : 'me-sm-1'">account_circle</i>
              <span class="dropdown-arrow"></span>
            </a>

            <ul class="dropdown-menu">
              <li class="nav-item d-flex align-items-center">
                <!-- Optional profile -->
              </li>
              <hr class="m-0" />
              <li class="nav-item d-flex align-items-center">
                <a
                    href="#"
                    @click.prevent="handleLogout"
                    class="px-0 nav-link font-weight-bold lh-1 d-flex align-items-center"
                >
                  <i class="material-icons ms-2" :class="isRTL ? 'ms-sm-2' : 'me-sm-1'">logout</i>
                  Logout
                </a>
              </li>
            </ul>
          </li>

          <!-- Sidebar toggle -->
          <li class="nav-item d-xl-none ps-3 d-flex align-items-center">
            <a
                href="#"
                @click.prevent="toggleSidebar"
                class="p-0 nav-link text-body lh-1"
                id="iconNavbarSidenav"
            >
              <div class="sidenav-toggler-inner">
                <i class="sidenav-toggler-line"></i>
                <i class="sidenav-toggler-line"></i>
                <i class="sidenav-toggler-line"></i>
              </div>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import Breadcrumbs from "../Breadcrumbs.vue";
import { mapMutations, mapState } from "vuex";

export default {
  name: "Navbar",
  components: {
    Breadcrumbs,
  },
  props: {
    minNav: Boolean,
    color: String,
  },
  computed: {
    ...mapState(["isRTL", "isAbsolute"]),
    currentRouteName() {
      return this.$route.name;
    },
  },
  methods: {
    ...mapMutations(["navbarMinimize", "toggleConfigurator"]),
    toggleSidebar() {
      this.navbarMinimize();
    },
    async handleLogout() {
      try {
        await this.$store.dispatch("auth/logout");
        this.$router.push({ name: "Login" });
      } catch (err) {
        console.error("Logout error:", err);
      }
    },
  },
};
</script>

<style scoped>
/* Dropdown arrow style */
.dropdown-arrow {
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 0.5em;
  vertical-align: middle;
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-left: 0.3em solid transparent;
}

/* ✅ Fully controllable logo style */
.integration-logo {
  height: 70px;           /* Adjust this to resize */
  max-width: 150px;       /* Prevent overflow */
  margin-top: 10px;      /* Adjust vertical position */
  object-fit: contain;
}

/* Optional: control logo container if needed */
.logo-wrapper {
  padding-left: 0;
  margin-right: 1rem;
}
</style>
